export default "__VITE_ASSET__Mwe6OlCZ__"